export default __webpack_public_path__ + "static/media/folder-icon-green-mian.84ecf583.svg";